// Multi-tenancy: типы для multi-org auth flow (см. handoff §15 от 2026-05-17).

export interface LoginV2Request {
  username: string;
  password: string;
  device_fingerprint?: string;
}

export interface SelectOrganizationRequest {
  organization_id: number;
}

export interface SwitchOrganizationRequest {
  organization_id: number;
}

export interface OrganizationSummary {
  id: number;
  code: string | null;
  name: string | null;
  /** ISO 8601 timestamp or null if user never logged in to this org */
  last_active_at: string | null;
}

/** Login response when user has exactly 1 active membership (auto-select). */
export interface LoginResponseAccess {
  access_token: string;
  token_type: 'bearer';
  organization: OrganizationSummary;
  /** Backend may include refresh_token / expires_in — keep optional for compat. */
  refresh_token?: string;
  expires_in?: number;
}

/** Login response when user has >1 active memberships (show org picker). */
export interface LoginResponsePreAuth {
  pre_auth_token: string;
  token_type: 'pre_auth';
  available_organizations: OrganizationSummary[];
}

/** Discriminated union for /auth/login-v2 response. */
export type LoginResponse = LoginResponseAccess | LoginResponsePreAuth;

export interface MeV2Response {
  user_id: number;
  username: string | null;
  email: string | null;
  is_admin: boolean;
  organization: OrganizationSummary;
  available_organizations: OrganizationSummary[];
}

export function isLoginAccess(r: LoginResponse): r is LoginResponseAccess {
  return r.token_type === 'bearer';
}

export function isLoginPreAuth(r: LoginResponse): r is LoginResponsePreAuth {
  return r.token_type === 'pre_auth';
}
